/* eslint-disable */
import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import Flickity from "flickity";
import lottie from 'lottie-web';
import Isotope from "isotope-layout";

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }

        window.dispatchEvent(new Event("resize"));
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** TOGGLE MENU */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();

          HTML.classList.toggle("open-menu");
        });
      });
    }

    this.favicon();
    this.push();
    this.slider();
    this.marquee();
    this.accordion();
    this.testimonials();
    this.projects();
    this.isotope();
    this.ajax();
    this.textareaResize();
    this.bodymovin();
    this.inViewport();
  }

  favicon() {
    const favicon_images = [
      `${urlTemplate}/static/img/favicon1.png`,
      `${urlTemplate}/static/img/favicon2.png`,
      `${urlTemplate}/static/img/favicon3.png`,
      `${urlTemplate}/static/img/favicon4.png`,
      `${urlTemplate}/static/img/favicon5.png`,
      `${urlTemplate}/static/img/favicon6.png`,
    ];
    let image_counter = 0; // To keep track of the current image

    setInterval(function () {
      // remove current favicon
      if (document.querySelector("link[rel='icon']") !== null)
        document.querySelector("link[rel='icon']").remove();
      if (document.querySelector("link[rel='shortcut icon']") !== null)
        document.querySelector("link[rel='shortcut icon']").remove();

      // add new favicon image
      document
        .querySelector("head")
        .insertAdjacentHTML(
          "beforeend",
          `<link rel="icon" href="${favicon_images[image_counter]}" type="image/png">`
        );

      // If last image then goto first image
      // Else go to next image
      if (image_counter == favicon_images.length - 1) image_counter = 0;
      else image_counter++;
    }, 400);
  }

  testimonials() {
    const containers = document.querySelectorAll(".testimonials");
    if (containers) {
      containers.forEach((el) => {
        if (window.innerWidth < 1024) {
          const flkty = new Flickity(el, {
            watchCSS: true,
            pageDots: false,
            prevNextButtons: false,
            cellSelector: ".item",
            cellAlign: "left",
            adaptiveHeight: true,
          });
        }
      });
    }
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {

          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: anim,
                  onComplete: () => {
                  },
                });
                tag.classList.add("loaded");
                tag.lottie = l;
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            tag.lottie.pause();
          }
        });
      });
    }
  }

  slider() {
    const sliders = document.querySelectorAll(".slider");

    if (sliders) {
      sliders.forEach((slider) => {
        let requestId;

        const flkty = new Flickity(slider, {
          cellAlign: "left",
          wrapAround: true,
          freeScroll: true,
          pageDots: false,
          cellSelector: ".item",
          prevNextButtons: false,
        });

        flkty.x = 0;

        // Start the marquee animation
        play();

        // Main function that 'plays' the marquee.
        function play() {
          flkty.x -= 0.5;
          flkty.settle(flkty.x);
          window.cancelAnimationFrame(requestId);
          requestId = window.requestAnimationFrame(play);
        }

        // Main function to cancel the animation.
        function pause() {
          if (requestId) {
            window.cancelAnimationFrame(requestId);
            requestId = undefined;
          }
        }

        // Pause on mouse over / focusin
        slider.addEventListener("mouseenter", pause, false);

        // Unpause on mouse out / focusout
        slider.addEventListener("mouseleave", play, false);

        slider.addEventListener("inview", play, false);
      });
    }
  }

  projects() {
    const containers = document.querySelectorAll(".projects");

    if (containers) {
      containers.forEach((el) => {
        const list = el.querySelector(".list");
        const filters = el.querySelectorAll("[data-filter]");

        if (list) {
          const items = list.querySelectorAll(".item");
          if (items && window.innerWidth >= 768) {
            window.addEventListener("resize", () => {
              let h = 0;
              items.forEach((item) => {
                if (item.offsetHeight > h) h = item.offsetHeight;
              });

              gsap.set(items, { height: h });
            });

            window.dispatchEvent(new Event("resize"));
          }

          const iso = new Isotope(list, {
            layoutMode: "masonry",
          });

          if (filters) {
            let current = 0;

            filters.forEach((filter, i) => {
              filter.addEventListener("click", (e) => {
                e.preventDefault();
                const target = filter.dataset.filter;

                if (current == i) return;

                filters[current].classList.remove("active");
                filters[i].classList.add("active");

                iso.arrange({
                  filter: `.${target}`,
                });

                current = i;
              });
            });
          }
        }
      });
    }
  }

  isotope() {
    const containers = document.querySelectorAll(".isotope");
    if (containers) {
      containers.forEach((el) => {
        const iso = new Isotope(el, {
          itemSelector: ".item",
          layoutMode: "masonry",
        });
      });
    }
  }

  push() {
    const containers = document.querySelectorAll(".push");

    if (containers) {
      containers.forEach((el) => {
        const medias = el.querySelectorAll(".medias");
        const triggers = el.querySelectorAll(".trigger");

        if (triggers && medias) {
          let current = -1;
          let timer = 0;

          medias.forEach((media) => {
            const tl = gsap.timeline({ paused: true });
            const m = media.querySelector(".media");
            const logos = media.querySelectorAll(".logo");

            tl.set(media, { autoAlpha: 1 })
              .fromTo(
                m,
                { autoAlpha: 0, borderRadius: "50%" },
                { duration: 0.4, autoAlpha: 1 }
              )
              .to(m, { duration: 0.5, borderRadius: "37.5%" }, "-=0.25");

            if (logos) {
              logos.forEach((logo, i) => {
                const shape = logo.querySelector(".shape");
                const img = logo.querySelector("img");
                tl.fromTo(
                  shape,
                  { scale: 0.5, autoAlpha: 0, rotate: "0deg" },
                  {
                    scale: 1,
                    autoAlpha: 1,
                    duration: 0.4,
                    rotate: "45deg",
                    ease: "circ.inOut",
                  },
                  `-=${i * 0.1 + 0.4}`
                ).fromTo(
                  img,
                  { autoAlpha: 0, scale: 1.1 },
                  { autoAlpha: 1, scale: 1 },
                  `-=${i * 0.1 + 0.2}`
                );
              });
            }

            media.timeline = tl;
          });

          function goto(i) {
            if (i == current) return false;

            let delay = 0;
            const timeScale = 2.5;

            clearTimeout(timer);

            if (medias[current]) {
              delay = medias[current].timeline.duration() / timeScale - 0.1;
              medias[current].timeline.timeScale(timeScale).reverse();
              triggers[current].classList.remove("active");
            }

            if (medias[i]) {
              timer = setTimeout(() => {
                medias[i].timeline.timeScale(1).play();
              }, delay * 1000);

              triggers[i].classList.add("active");
            }

            current = i;
          }

          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              goto(i);
            });
          });

          el.addEventListener("inview", () => {
            if (current < 0) goto(0);
          });
        }
      });
    }
  }

  marquee() {
    const marquees = document.querySelectorAll(".marquee");

    if (marquees) {
      let pas = 0.75;

      function wheel(e) {
        const orgin = 0.75;
        pas = (e.deltaY < 0 ? -1 : 1) * orgin;
      }

      window.addEventListener("wheel", wheel);

      window.addEventListener("unmount", () => {
        window.removeEventListener("wheel", wheel);
      });

      marquees.forEach((el) => {
        const line = el.querySelector('.line');
        
        let scrollDirection = 1; // 1 = gauche, -1 = droite
        let speed = 40; // Pixels par seconde

        // Duplique les images pour un effet continu
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();

        // Calcule la largeur totale de la marquee
        const marqueeWidth = line.scrollWidth / 2;

        // Initialise la position
        let position = 0;

        // Animation continue
        const animate = (timestamp) => {
          position += (speed / 60) * -scrollDirection; // Ajuste selon la vitesse et direction

          // Réinitialise la position si elle dépasse la largeur totale
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }

          line.style.transform = `translateX(${position}px)`;
          requestAnimationFrame(animate);
        };

        // Écouteur pour changer la direction en fonction du scroll
        let lastScrollY = window.scrollY;
        window.addEventListener('scroll', () => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY) {
            scrollDirection = 1; // Scroll vers le bas : gauche
          } else if (currentScrollY < lastScrollY) {
            scrollDirection = -1; // Scroll vers le haut : droite
          }
          lastScrollY = currentScrollY;
        });

        // Lance l'animation
        requestAnimationFrame(animate);
        // const flkty = new Flickity(el, {
        //   // cellAlign: "left",
        //   freeScroll: true,
        //   prevNextButtons: false,
        //   pageDots: false,
        //   wrapAround: true,
        //   draggable: false,
        //   percentPosition: false
        // });

        // console.log(flkty)

        // flkty.request = 0;
        // let scrollSpeed = 1; // Ajustez pour contrôler la vitesse
        // function startMarquee() {
        //   setInterval(() => {
        //     flkty.x -= scrollSpeed; // Déplace le carousel vers la gauche
        //     // flkty.settle(flkty.x);
        //     flkty.positionSlider(); // Met à jour la position des slides
        //     // gsap.set(flkty.slider, { left : `${flkty.x}px` });
        //   }, 16); // Fréquence d'animation (~60 FPS)
        // }
      
        // startMarquee();

        // function launch() {
        //   el.removeEventListener("inview", launch);
        //   play();
        // }
        // function play() {
        //   flkty.x -= Number.parseFloat(el.dataset.dir) * pas;
        //   flkty.settle(flkty.x);
        //   flkty.request = window.requestAnimationFrame(play);
        // }

        // el.addEventListener("inview", launch);
        // el.addEventListener("outview", (e) => {
        //   window.cancelAnimationFrame(flkty.request);
        //   el.addEventListener("inview", launch);
        // });

        // window.addEventListener("unmount", () => {
        //   flkty.destroy();
        //   window.cancelAnimationFrame(flkty.request);
        //   el.removeEventListener("inview", launch);
        // });
      });
    }
  }

  accordion() {
    const containers = document.querySelectorAll(".accordion");

    if (containers) {
      containers.forEach((el) => {
        const headers = el.querySelectorAll(".accordion-header");
        const contents = el.querySelectorAll(".accordion-content");

        if (contents && headers) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();
              if (contents[i]) {
                contents[i]
                  .closest(".accordion-item")
                  .classList.toggle("active");

                const h = contents[i]
                  .closest(".accordion-item")
                  .classList.contains("active")
                  ? contents[i].children[0].offsetHeight
                  : 0;

                gsap.to(contents[i], {
                  duration: 0.6,
                  ease: "expo.inOut",
                  autoAlpha: h > 0 ? 1 : 0,
                  height: h,
                });
              }
            });
          });
        }
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  ajax() {
    const triggers = document.querySelectorAll("[data-ajax]");

    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();

          trigger.classList.add("onload");
          const { href } = trigger;
          const container = document.querySelector(trigger.dataset.ajax);

          fetch(href)
            .then((response) => {
              return response.text();
            })
            .then((html) => {
              const output = document.createElement("html");
              output.innerHTML = html;

              const outputList = output.querySelector(trigger.dataset.ajax);

              const iso = Isotope.data(container);
              if (iso) {
                iso.insert(outputList.querySelectorAll(".item"));

                const newAjax = output.querySelector(".pager a");
                if (newAjax) {
                  trigger.href = newAjax.href;
                } else {
                  gsap.to(trigger.parentNode, {
                    height: 0,
                    overflow: "hidden",
                  });
                }
              } else {
                container.append(outputList);
              }

              this.lazyload.update();
              this.inViewport();

              trigger.classList.remove("onload");
            });

          return false;
        });
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.old-content):not(.is-visible")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
